/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import subCustomerFieldsetTemplate from './subcustomer-fieldset.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function SubCustomerDirective($compile, $templateCache, $translate, toast) {
    var linker = function (scope, element) {
        var template = $templateCache.get(subCustomerFieldsetTemplate);
        element.html(template);

        scope.onSubCustomerIdCopied = function() {
            toast.showSuccess($translate.instant('subCustomer.idCopiedMessage'), 750, angular.element(element).closest(".toast-parent"), 'bottom left');
        };

        $compile(element.contents())(scope);
    }
    return {
        restrict: "E",
        link: linker,
        scope: {
            subCustomer: '=',
            isEdit: '=',
            theForm: '='
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/subcustomer/subcustomer.directive.js